"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCleanedFileName;

function getCleanedFileName(fileName) {
  var modifiedFileName = fileName.replace(/\s+/g, '-').toLowerCase();
  var fileNameArray = modifiedFileName.split('.');
  var extension = fileNameArray[fileNameArray.length - 1];
  delete fileNameArray[fileNameArray.length - 1];
  fileNameArray = fileNameArray.filter(function (r) {
    return r;
  });
  var newFileName = "".concat(fileNameArray.join('-'), ".").concat(extension);
  return newFileName;
}